module.exports = __webpack_public_path__ + "img/exit_6.c84206eb.svg";